import fl1stScience from "./fl1stScienceQuizContent";
import fl1stSocialStudies from "./fl1stSocialStudiesQuizContent";
import fl1stMath from "./fl1stMathQuizContent";
import fl1stOther from "./fl1stOtherQuizContent";

// 2nd Grade
import fl2ndScience from "./fl2ndScienceQuizContent";
import fl2ndSocialStudies from "./fl2ndSocialStudiesQuizContent";
import fl2ndMath from "./fl2ndMathQuizContent";
import fl2ndOther from "./fl2ndOtherQuizContent";

// 3rd Grade
import fl3rdScience from "./fl3rdScienceQuizContent";
import fl3rdSocialStudies from "./fl3rdSocialStudiesQuizContent";
import fl3rdMath from "./fl3rdMathQuizContent";
import fl3rdOther from "./fl3rdOtherQuizContent";

// 4th Grade
import fl4thScience from "./fl4thScienceQuizContent";
import fl4thSocialStudies from "./fl4thSocialStudiesQuizContent";
import fl4thMath from "./fl4thMathQuizContent";
import fl4thOther from "./fl4thOtherQuizContent";

// 5th Grade
import fl5thScience from "./fl5thScienceQuizContent";
import fl5thSocialStudies from "./fl5thSocialStudiesQuizContent";
import fl5thMath from "./fl5thMathQuizContent";
import fl5thOther from "./fl5thOtherQuizContent";
// ...import the


// Keep your existing keys ← these are what MapPage already uses
export const fltopicsMapBySubject = {
    // 1st Grade
    fl_1st_science: fl1stScience,
    fl_1st_socialstudies: fl1stSocialStudies,
    fl_1st_math: fl1stMath,
    fl_1st_other: fl1stOther,
  
    // 2nd Grade
    fl_2nd_science: fl2ndScience,
    fl_2nd_socialstudies: fl2ndSocialStudies,
    fl_2nd_math: fl2ndMath,
    fl_2nd_other: fl2ndOther,
  
    // 3rd Grade
    fl_3rd_science: fl3rdScience,
    fl_3rd_socialstudies: fl3rdSocialStudies,
    fl_3rd_math: fl3rdMath,
    fl_3rd_other: fl3rdOther,
  
    // 4th Grade
    fl_4th_science: fl4thScience,
    fl_4th_socialstudies: fl4thSocialStudies,
    fl_4th_math: fl4thMath,
    fl_4th_other: fl4thOther,
  
    // 5th Grade
    fl_5th_science: fl5thScience,
    fl_5th_socialstudies: fl5thSocialStudies,
    fl_5th_math: fl5thMath,
    fl_5th_other: fl5thOther,
    // ...add the rest
  };